export enum TranslationActionTypes {
    SET_TRANSLATIONS = 'SET_TRANSLATIONS',
}